import { Typography } from '@mui/material';
import React from 'react'
import { formatCompletedTaskTime } from './timeFormat';

interface timeStampActionProps {
    actionValue?: any;
    action?: string;
    actionIndex?: number;
    result?: any;
    projectStatus?: string;

}
const TimeStampAction = ({ actionValue }: timeStampActionProps) => {
    return (
        <>
            {actionValue && actionValue?.map((action: any, index: number) => (
                <div key={index} style={{ display: 'flex', marginBottom: '10px', flexDirection: 'column' }}>
                    {/* <Typography sx={{ fontWeight: 'bold', marginRight: '20px' }}>{action?.config_details?.transcribe} </Typography> */}
                    {action ? (
                        
                        <Typography sx={{ marginLeft: '0px', color: 'black', fontWeight: 'bold' }}>
                            <strong>Timestamp:</strong> {formatCompletedTaskTime(action?.timestamp)} (HH:MM:SS:mm)
                            
                        </Typography>
                        
                    ) : (
                        <Typography sx={{ marginLeft: '10px', color: 'gray' }}>
                            No Timestamp data available.
                        </Typography>
                    )}
                </div>
            ))}
        </>
    )
}

export default TimeStampAction